<div class="job-details-main-container">
  <div class="fixed-back" (click)="navigateBack()">
    <a [routerLink]="['/hiring-manager']"
      ><emerald-icon
        [ariaLabel]="'Back'"
        [fontsizeInRem]="0.9"
        [icon]="'arrow_back'"
      ></emerald-icon
      ><span class="back_link">Back</span></a
    >
  </div>
  <div class="view-details">
    <div class="Job-details">
      <div class="jd-head-main">
        <h3 class="heading">
          <ng-container *ngIf="sharedservice?.jobDetails?.[0]?.jobTitle; else defaultTitle">
            {{ sharedservice.jobDetails[0].jobTitle }}
          </ng-container>
          <ng-template #defaultTitle>
            {{ currentJobTitle }}
          </ng-template>
        </h3>
        <div class="jd-meta">
          <span class="jd-meta-item"><span class="k">Project</span><span class="v">{{ projectName || '—' }}</span></span>
          <span class="jd-meta-item"><span class="k">Hiring Manager</span><span class="v">{{ hiringManagerName || '—' }}</span></span>
          <span class="jd-meta-item"><span class="k">Primary Skills</span><span class="v">{{ primarySkills || '—' }}</span></span>
          <span class="jd-meta-item"><span class="k">Candidates Received</span><span class="v">{{ totalCount }}</span></span>
        </div>
      </div>
  <div class="dropdown-button">
    <div class="status">
      <emerald-button
        [type]="'Secondary'"
        [size]="'Medium'"
        (click)="confirmStatusChange()"
      >
        <span class="status-label">{{ requeststatusoption || 'Change Status' }}</span>
        <emerald-icon icon="edit" type="outlined" class="edit-icon"></emerald-icon>
      </emerald-button>
    </div>
    <div class="button">
      <emerald-button *ngIf="filePath"
        [type]="'Light'"
        [label]="'Job Description'"
        [size]="'Large'"
        (onClick)="job_Description('jobDescription')"
        [icon]="'download'"
      ></emerald-button>
    </div>
  </div>
  <div *ngIf="showAlert" class="alert-overlay" (click)="closeAlert()">
    <div class="alert-container" (click)="$event.stopPropagation()">
      <h2 class="alert-question">
        Please confirm the status of the position “{{ currentJobTitle }}”?
      </h2>
      <div class="actions">
        <emerald-button
          [type]="'Secondary'"
          [label]="statusEnum.OnHold"
          (onClick)="updateStatus(statusEnum.OnHold)"
          [ngClass]="{'selected-status': requeststatusoption === statusEnum.OnHold}"
        ></emerald-button>
        <emerald-button
          [type]="'Secondary'"
          [label]="statusEnum.Closed"
          (onClick)="updateStatus(statusEnum.Closed)"
          [ngClass]="{'selected-status': requeststatusoption === statusEnum.Closed}"
        ></emerald-button>
        <emerald-button
          [type]="'Secondary'"
          [label]="statusEnum.Open"
          (onClick)="updateStatus(statusEnum.Open)"
          [ngClass]="{'selected-status': requeststatusoption === statusEnum.Open}"
        ></emerald-button>
      </div>
    </div>
  </div>
    </div>
    <div class="job-details-search">
      <div class="search-bar-container">
        <div class="search-child">
          <emerald-input
            [label]="'Search'"
            [trailingIcon]="'search'"
            (keyup)="applyJobDetails($event)"
            [value]="filterValue"
            ><emerald-icon
              *ngIf="filterValue?.length && filterValue.length > 0"
            [icon]="'close'"
            (click) = "clearInput()"
          ></emerald-icon>
          </emerald-input>
        </div>
          <div class="op-filter-slot">
            <button class="op-filterbtn" (click)="toggleFilterPanel()">
              <emerald-icon>filter_list</emerald-icon> Filters
              <span class="op-filter-count" *ngIf="activeFilterCount">{{ activeFilterCount }}</span>
            </button>
            <div class="op-filter-backdrop" *ngIf="showFilterPanel" (click)="showFilterPanel = false"></div>
            <div class="op-filter-panel" *ngIf="showFilterPanel">
              <div class="op-fp-head">Filter candidates</div>
              <div class="op-fp-row">
                <label class="op-fp-label">Location</label>
                <select class="op-fp-field" [(ngModel)]="jdFilterDraft.location">
                  <option value="">All</option>
                  <option *ngFor="let v of facetLocation" [value]="v">{{ v }}</option>
                </select>
              </div>
              <div class="op-fp-row">
                <label class="op-fp-label">Experience</label>
                <select class="op-fp-field" [(ngModel)]="jdFilterDraft.experience">
                  <option value="">All</option>
                  <option *ngFor="let v of facetExperience" [value]="v">{{ v }}</option>
                </select>
              </div>
              <div class="op-fp-actions">
                <button class="op-fp-reset" (click)="resetFilterPanel()">Reset</button>
                <button class="op-fp-apply" (click)="applyFilterPanel()">Apply</button>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="job_details-table">
      <ng-container
        *ngIf="displayData && displayData?.length; else noDataTemplate"
      >
        <emerald-datatable
          [columnDefs]="columnDefs"
          [rowData]="displayData"
          [paginationParams]="paginationParams"
          [allowResizeColumns]="true"
          [customCellTemplate]="{
            location: customLocationColumn,
            email: customEmail,
            resume: customResumeColumn,
            attachments: customAttachmentsColumn,
            url: customLinkColumn,
            review: customReviewColumn,
            earliestAvailability: customAvailableByColumn,
            createdDate: customReceivedOnColumn,
          }"
        >
        </emerald-datatable>
      </ng-container>
      <ng-template #noDataTemplate>
        <section class="records-container" aria-label="Records section">
          <div class="empty-state">
            <ng-container *ngIf="isDataLoaded">
              <h2 class="empty-state-title">{{errorMsg}}</h2>
            </ng-container>
            <img [src]="imageSrc" alt="No records illustration" class="empty-state-image" />
          </div>
        </section>
      </ng-template>
      <ng-template #customLocationColumn let-level="level" let-eachRow="eachRow">
        {{ eachRow?.location?.join(', ') }}
      </ng-template>
      <ng-template #customResumeColumn let-level="level" let-eachRow="eachRow">
        <emerald-button *ngIf="eachRow?.resumePath"
          className="small_button"
          [type]="'Light'"
          [label]="''"
          [size]="'Small'"
          [icon]="'download'"
          (onClick)="downloadFile(eachRow?.resumePath, eachRow?.candidateName, 'resume')"
        ></emerald-button>
      </ng-template>
      <ng-template
        #customAttachmentsColumn
        let-level="level"
        let-eachRow="eachRow"
      >
        <emerald-button *ngIf="eachRow?.additionalDocumentsPath"
          className="small_button"
          [type]="'Light'"
          [label]="''"
          [size]="'Small'"
          [icon]="'download'"
          (onClick)="downloadFile(eachRow?.additionalDocumentsPath, eachRow?.candidateName, 'attachments')"
        ></emerald-button>
      </ng-template>
      <ng-template #customLinkColumn let-level="level" let-eachRow="eachRow">
        <a class="link-color" (click)="openUrlNewTab(eachRow?.url)" [href]="eachRow?.url | addHttps">{{
          eachRow?.url?.length > urlDisplayLimit
          ? eachRow?.url?.substring(0, urlDisplayLimit) + "..."
          : eachRow?.url
        }}</a>
      </ng-template>
      <ng-template #customEmail let-level="level" let-eachRow="eachRow">
        {{ eachRow?.emailId }}
      </ng-template>
      <ng-template
        #customReviewColumn
        let-row="row"
        let-level="level"
        let-eachRow="eachRow"
      >
         <app-candidate-feedback (sendFeedbackStatus)="receiveData($event,eachRow.emailId)" [candidateId]="eachRow.candidateId" [fieldsVisibility]="fieldsVisibility" *ngIf="fieldsVisibility && eachRow.emailId"></app-candidate-feedback>
      </ng-template>
    <ng-template #customAvailableByColumn let-level="level" let-eachRow="eachRow">
      <span>{{
        eachRow?.earliestAvailability | date: dateFormat.Month
      }}</span></ng-template
    >
    <ng-template #customReceivedOnColumn let-level="level" let-eachRow="eachRow">
      <span>{{
        eachRow?.createdDate | date: dateFormat.Month
      }}</span></ng-template
    >
    </div>
  </div>
</div>
